<template>
  <footer
    :class="[$store.state.isNavigation && !$store.state.isLoading ? 'pb-16 md:pb-20' : '', 'mt-5 md:mt-0 footer']"
  >
    <div class="bg-white border-t-2 border-semantic-base30 text-semantic-base font-normal">
      <div class="container mx-auto text-sm py-4 xl:py-7">
        <div class="flex flex-col md:flex-row md:justify-between">
          <div class="lg:w-1/3"></div>
          <div class="flex lg:w-1/3 items-center justify-center">
            <a
              href="https://www.novonesis.com/en/legal-notice-and-terms-use"
              target="_blank"
              rel="noopener noreferrer"
              class="px-5"
            >
              <span> Legal Notice & Terms of Use</span>
            </a>
            <a href="https://www.novonesis.com/en/privacy-policy" target="_blank" class="px-5">
              <span> Privacy Policy </span>
            </a>
          </div>
          <div class="mt-3.5 lg:w-1/3 md:mt-0">
            <p class="text-center">Copyright © 2025 Novozymes A/S, part of Novonesis Group</p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Footer',
  computed: {
    ...mapGetters({
      getSelectedProduct: 'productSelect/getSelectedProduct',
    }),

    isLogin() {
      const enableRouteNames = [
        'login',
        'register',
        'reset-password',
        'request-verification-email',
        'confirm-email',
        'product-selection',
      ];
      return enableRouteNames.includes(this.$route.name);
    },
  },
};
</script>
